import MergesIndex from "./MergesIndex";
export default MergesIndex;
